export const PRIVACY_POLICY = 'privacyPolicy';
export const TERMS_AND_CONDITION = 'termsAndCondition';
export const defaultVoice = 'en-US-JennyNeural';
export const emptyTranscriptText = "Okay, I didn't hear from you. No worries!";
export const irrelevantText = 'No worries!';
export const PageSize = 10;
export const STATUSES = {
    ACTIVE: 'Active',
    OPEN_POSITION: 'Open Position',
    CLOSED: 'Closed',
    CLOSED_POSITION: 'Closed Position',
    CANCELED: 'Canceled',
    CAUTIOUSLY_RECOMMENDED: 'Cautiously Recommended',
    IN_PROGRESS: 'In Progress',
    INVITED: 'Invited',
    INVITE_SENT: 'Invite Sent',
    NOT_RECOMMENDED: 'Not Recommended',
    PENDING: 'Pending',
    RECOMMENDED: 'Recommended',
    UNATTENDED: 'Unattended',
    NETWORK_DISCONNECTED: 'Network Disconnected',
    REINVITED: 'Reinvited',
    RESUME_REJECTED: 'Resume Rejected',
    INCOMPLETE_DATA: 'Incomplete Data',
    COMPLETED: 'Completed',
};
export const TABS = {
    ALL_CANDIDATES: 'All Candidates',
    COMPLETED_INTERVIEWS: 'Completed Interviews',
    NETWORK_DISCONNECTED: 'Network Disconnected',
};
export const TOAST_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
};
export const SUCCESS_MSG = {
    FILE_UPLOAD: 'File uploaded successfully.',
};
export const SEARCH_PLACEHOLDER = 'Search here...';
export const EXCLUDED_TEXT = ["let's start the interview.", "time's up please end the interview"];
